module.exports = __webpack_public_path__ + "static/media/179.e4dbc19b.svg";